(function () {
  angular.module("akitabox.ui.dialogs.job.viewStepLog", [
    "ngMaterial",
    "akitabox.core.constants",
  ]);
})();
